<template>
  <div ref="bigText" class="big-text" :class="{'animateText': animateText}">{{text}}</div>
</template>
<script>
export default {
  name: "LargeTextAnimation",
  mounted(){
        this.calculateWidth()
  },
  props: ['text','showTopics','subject'],
  data() {
    return {
         animateText:false
    };
  },
  watch:{
      showTopics(val){
          this.calculateWidth();
      },
      subject(val){
          this.calculateWidth();
      }
  },
  methods: {
    calculateWidth(){
        this.$nextTick(() => {
         let elem=this.$refs.bigText
         if(elem){
           if(elem.scrollWidth > elem.clientWidth){
              this.animateText=true
            } 
            else{
               this.animateText=false;
            }
         }
        });  
      }
    }
};
</script>

<style>
@keyframes floatText {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

.animateText {
  position: relative;
  white-space: nowrap;
  animation: floatText 7s infinite linear;
}
</style>